import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../auth/base/services/auth.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(
    private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly translateService: TranslateService
  ) {}

  public init(): void {
    this.translateService.setDefaultLang('en');
    this.authService.init();
    this.userService.init();
  }
}
